import { apiPath } from '@/redux/apiPath';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { ThunkConfig } from '@/types/store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getError } from '@/utils/error-report/getError';
import { RemoveCommentPayload } from '../comment.types';

export const removeComment = createAsyncThunk<void, RemoveCommentPayload, ThunkConfig>(
  'comment/removeComment',
  async ({ projectId, mapId, commentId, reason }) => {
    try {
      await axiosInstanceNewAPI.delete(apiPath.removeComment(projectId, mapId, commentId), {
        data: { reason },
      });
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(getError({ error }));
    }
  },
);
